export const NotificationEndpoint = {
  getNotification: "notifications/getNotificationByUserId",
  readNotification: "notifications/readNotification",
  markAllRedNotification: "notifications/markAllRead",

  getAnnouncement: "announcements/getAnnouncements",
};
